import * as XLSX from 'xlsx'
import store from '@/store'

export default function useExportARI() {
  const { client } = store.state?.userStore?.userData
  const clientData = JSON.parse(localStorage.getItem("clientData") || '{}')
  const clientName = clientData?.name || client?.name || 'Cliente'

  const exportToExcel = (analyses) => {
    if (!analyses) {
      return
    }

    // Create workbook
    const wb = XLSX.utils.book_new()

    // Add ARI sheet with analyses
    addARISheet(wb, analyses)

    // Generate filename
    const today = new Date().toISOString().split('T')[0]
    const filename = `ARI_${today}.xlsx`
    XLSX.writeFile(wb, filename)
  }

  const addARISheet = (wb, analyses) => {
    // Fila 1: Título principal (A1:AN1)
    const headerRow1 = [
      'ANÁLISIS DE RIESGOS INHERENTES (ARI)', // A1
      ...Array(39).fill('') // B1-AN1 (merged with A1)
    ]

    // Fila 2: Secciones principales
    const headerRow2 = [
      'IDENTIFICACIÓN', // A2
      '', '', '', '', // B2-E2 (merged with A2)
      'TIPO DE DATO', // F2
      'CARACTERÍSTICAS DEL TRATAMIENTO', // G2
      '', '', '', '', // H2-K2 (merged with G2)
      'PRINCIPIOS', // L2
      '', '', '', '', '', '', // M2-R2 (merged with L2)
      'TRANSMISIÓN O CESIÓN DE DATOS', // S2
      '', '', '', '', // T2-W2 (merged with S2)
      'EVALUACIÓN DE IMPACTO EN PROTECCIÓN DE DATOS', // X2
      '', '', '', '', // Y2-AB2 (merged with X2)
      'OBLIGATORIEDAD LEGAL (Ley 21.719)', // AC2
      '', '', '', // AD2-AF2 (merged with AC2)
      'CÁLCULO DEL RIESGO INHERENTE', // AG2
      '', '', '', // AH2-AJ2 (merged with AG2)
      'EVALUACIÓN EIPD', // AK2
      '', '', '' // AL2-AN2 (merged with AK2)
    ]

    // Fila 3: Títulos individuales de cada columna
    const headerRow3 = [
      'ID', // A3
      'TRATAMIENTO DE DATOS', // B3
      '¿Tiene sensibles?', // C3
      '¿Tiene NNA?', // D3
      '¿Tiene biométricos?', // E3
      'Tipo de dato', // F3
      'Geolocalización', // G3
      'Periodicidad', // H3
      'Volumen', // I3
      'Medios de soporte', // J3
      'Origen', // K3
      'Legitimación', // L3
      'Finalidad', // M3
      'Excepción datos sensibles', // N3
      'Proporcionalidad', // O3
      'Calidad de los datos', // P3
      'Información y transparencia', // Q3
      'Conservación', // R3
      'Cesiones', // S3
      'Medios de soporte cesión', // T3
      'Encargados del tratamiento', // U3
      'Medidas de soporte encargo', // V3
      'Transferencias', // W3
      'Tratamiento masivo de datos', // X3
      'Monitoreo sistemático de zona pública', // Y3
      'Elaboración de perfiles', // Z3
      'Decisiones automatizadas', // AA3
      'Uso de tecnologías innovadoras/invasivas', // AB3
      'OL-a: Evaluación sistemática + decisiones automatizadas con efectos jurídicos', // AC3
      'OL-b: Tratamiento masivo o a gran escala', // AD3
      'OL-c: Observación/monitoreo sistemático de zona pública', // AE3
      'OL-d: Sensibles sin excepción de consentimiento', // AF3
      'P (Probabilidad)', // AG3
      'I (Impacto)', // AH3
      'RIESGO INHERENTE', // AI3
      'NIVEL DE RIESGO', // AJ3
      'REQUIERE EIPD (calculado)', // AK3
      'EIPD OVERRIDE (opcional)', // AL3
      'JUSTIFICACIÓN OVERRIDE', // AM3
      'EIPD FINAL' // AN3
    ]

    // Build data rows from analyses
    const dataRows = analyses.map(analysis => {
      const treatment = analysis.treatment || {}
      const scores = analysis.scores || {}
      const legalObligations = analysis.legalObligations || {}

      return [
        analysis.treatmentId || '', // A: ID
        analysis.treatmentName || '', // B: TRATAMIENTO DE DATOS
        treatment.hasSensitive ? 'Sí' : 'No', // C: ¿Tiene sensibles?
        treatment.hasMinors ? 'Sí' : 'No', // D: ¿Tiene NNA?
        treatment.hasBiometric ? 'Sí' : 'No', // E: ¿Tiene biométricos?
        formatScore(scores.i_tipo_dato), // F: Tipo de dato
        formatScore(scores.i_geolocalizacion), // G: Geolocalización
        formatScore(scores.p_periodicidad), // H: Periodicidad
        formatScore(scores.i_volumen), // I: Volumen
        formatScore(scores.p_medios_soporte), // J: Medios de soporte
        formatScore(scores.p_origen), // K: Origen
        formatScore(scores.p_legitimacion), // L: Legitimación
        formatScore(scores.i_finalidad), // M: Finalidad
        formatScore(scores.p_excepcion_sens), // N: Excepción datos sensibles
        formatScore(scores.i_proporcionalidad), // O: Proporcionalidad
        formatScore(scores.p_calidad_datos), // P: Calidad de los datos
        formatScore(scores.p_info_transp), // Q: Información y transparencia
        formatScore(scores.p_conservacion), // R: Conservación
        formatScore(scores.i_cesiones), // S: Cesiones
        formatScore(scores.p_soporte_cesion), // T: Medios de soporte cesión
        formatScore(scores.i_encargados), // U: Encargados del tratamiento
        formatScore(scores.p_medidas_encargo), // V: Medidas de soporte encargo
        formatScore(scores.i_transferencias), // W: Transferencias
        formatScore(scores.eipd_masivo), // X: Tratamiento masivo de datos
        formatScore(scores.eipd_monitoreo_publico), // Y: Monitoreo sistemático de zona pública
        formatScore(scores.eipd_perfiles), // Z: Elaboración de perfiles
        formatScore(scores.eipd_dec_automatizadas), // AA: Decisiones automatizadas
        formatScore(scores.eipd_tecnologias_invasivas), // AB: Uso de tecnologías innovadoras/invasivas
        legalObligations.ol_a ? 'Sí' : 'No', // AC: OL-a
        legalObligations.ol_b ? 'Sí' : 'No', // AD: OL-b
        legalObligations.ol_c ? 'Sí' : 'No', // AE: OL-c
        legalObligations.ol_d ? 'Sí' : 'No', // AF: OL-d
        analysis.calculatedP || '', // AG: P (Probabilidad)
        analysis.calculatedI || '', // AH: I (Impacto)
        analysis.inherentRisk || '', // AI: RIESGO INHERENTE
        analysis.inherentLevel || '', // AJ: NIVEL DE RIESGO
        analysis.requiresEipdAuto ? 'Sí' : 'No', // AK: REQUIERE EIPD (calculado)
        analysis.eipdOverride !== null ? (analysis.eipdOverride ? 'Sí' : 'No') : '', // AL: EIPD OVERRIDE
        analysis.eipdOverrideJustification || '', // AM: JUSTIFICACIÓN OVERRIDE
        analysis.eipdFinal ? 'Sí' : 'No' // AN: EIPD FINAL
      ]
    })

    // Create worksheet with headers (3 header rows + data)
    const wsData = [headerRow1, headerRow2, headerRow3, ...dataRows]
    const ws = XLSX.utils.aoa_to_sheet(wsData)

    // Set column widths (A-AN = 40 columns)
    ws['!cols'] = [
      { wch: 10 },  // A: ID
      { wch: 40 },  // B: TRATAMIENTO DE DATOS
      { wch: 12 },  // C: ¿Tiene sensibles?
      { wch: 12 },  // D: ¿Tiene NNA?
      { wch: 12 },  // E: ¿Tiene biométricos?
      { wch: 12 },  // F: Tipo de dato
      { wch: 15 },  // G: Geolocalización
      { wch: 15 },  // H: Periodicidad
      { wch: 12 },  // I: Volumen
      { wch: 18 },  // J: Medios de soporte
      { wch: 12 },  // K: Origen
      { wch: 15 },  // L: Legitimación
      { wch: 15 },  // M: Finalidad
      { wch: 20 },  // N: Excepción datos sensibles
      { wch: 15 },  // O: Proporcionalidad
      { wch: 18 },  // P: Calidad de los datos
      { wch: 22 },  // Q: Información y transparencia
      { wch: 15 },  // R: Conservación
      { wch: 12 },  // S: Cesiones
      { wch: 20 },  // T: Medios de soporte cesión
      { wch: 22 },  // U: Encargados del tratamiento
      { wch: 22 },  // V: Medidas de soporte encargo
      { wch: 15 },  // W: Transferencias
      { wch: 25 },  // X: Tratamiento masivo de datos
      { wch: 30 },  // Y: Monitoreo sistemático de zona pública
      { wch: 20 },  // Z: Elaboración de perfiles
      { wch: 22 },  // AA: Decisiones automatizadas
      { wch: 32 },  // AB: Uso de tecnologías innovadoras/invasivas
      { wch: 45 },  // AC: OL-a
      { wch: 30 },  // AD: OL-b
      { wch: 40 },  // AE: OL-c
      { wch: 40 },  // AF: OL-d
      { wch: 15 },  // AG: P (Probabilidad)
      { wch: 12 },  // AH: I (Impacto)
      { wch: 18 },  // AI: RIESGO INHERENTE
      { wch: 18 },  // AJ: NIVEL DE RIESGO
      { wch: 20 },  // AK: REQUIERE EIPD (calculado)
      { wch: 20 },  // AL: EIPD OVERRIDE (opcional)
      { wch: 35 },  // AM: JUSTIFICACIÓN OVERRIDE
      { wch: 15 }   // AN: EIPD FINAL
    ]

    // Add row heights
    if (!ws['!rows']) ws['!rows'] = []
    ws['!rows'][0] = { hpt: 25 } // Header row 1
    ws['!rows'][1] = { hpt: 25 } // Header row 2
    ws['!rows'][2] = { hpt: 35 } // Header row 3 (column titles)

    // Style header rows with background color
    const headerRange = XLSX.utils.decode_range(ws['!ref'])
    for (let R = 0; R <= 2; R++) {
      for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
        const address = XLSX.utils.encode_cell({ r: R, c: C })
        if (!ws[address]) continue
        ws[address].s = {
          fill: { fgColor: { rgb: '2F5496' } },
          font: { bold: true, color: { rgb: 'FFFFFF' }, sz: 10 },
          alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
          border: {
            top: { style: 'thin', color: { rgb: '000000' } },
            bottom: { style: 'thin', color: { rgb: '000000' } },
            left: { style: 'thin', color: { rgb: '000000' } },
            right: { style: 'thin', color: { rgb: '000000' } }
          }
        }
      }
    }

    // Merge cells for header groups
    if (!ws['!merges']) ws['!merges'] = []

    // Fila 1: ANÁLISIS DE RIESGOS INHERENTES (ARI) (A1:AN1)
    ws['!merges'].push({ s: { r: 0, c: 0 }, e: { r: 0, c: 39 } })

    // Fila 2: IDENTIFICACIÓN (A2:E2)
    ws['!merges'].push({ s: { r: 1, c: 0 }, e: { r: 1, c: 4 } })

    // Fila 2: TIPO DE DATO (F2) - no merge, single cell
    // (Column F is standalone)

    // Fila 2: CARACTERÍSTICAS DEL TRATAMIENTO (G2:K2)
    ws['!merges'].push({ s: { r: 1, c: 6 }, e: { r: 1, c: 10 } })

    // Fila 2: PRINCIPIOS (L2:R2)
    ws['!merges'].push({ s: { r: 1, c: 11 }, e: { r: 1, c: 17 } })

    // Fila 2: TRANSMISIÓN O CESIÓN DE DATOS (S2:W2)
    ws['!merges'].push({ s: { r: 1, c: 18 }, e: { r: 1, c: 22 } })

    // Fila 2: EVALUACIÓN DE IMPACTO EN PROTECCIÓN DE DATOS (X2:AB2)
    ws['!merges'].push({ s: { r: 1, c: 23 }, e: { r: 1, c: 27 } })

    // Fila 2: OBLIGATORIEDAD LEGAL (AC2:AF2)
    ws['!merges'].push({ s: { r: 1, c: 28 }, e: { r: 1, c: 31 } })

    // Fila 2: CÁLCULO DEL RIESGO INHERENTE (AG2:AJ2)
    ws['!merges'].push({ s: { r: 1, c: 32 }, e: { r: 1, c: 35 } })

    // Fila 2: EVALUACIÓN EIPD (AK2:AN2)
    ws['!merges'].push({ s: { r: 1, c: 36 }, e: { r: 1, c: 39 } })

    XLSX.utils.book_append_sheet(wb, ws, 'ARI')
  }

  // Helper function to format scores
  const formatScore = (score) => {
    if (score === null || score === undefined) return ''
    if (score === 'NA') return 'N/A'
    return score
  }

  return {
    exportToExcel
  }
}
